import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { trackRoute } from "./monitor-context"

export function RouteTracker() {
  const location = useLocation()

  useEffect(() => {
    trackRoute(location.pathname)
  }, [location.pathname])

  return null
}
